import { mfestsApi } from "api/mfests_api";

export const getFestivalsUpcoming = async ({ authToken }) => {
  const data = await mfestsApi.get({ authToken, url: `festivals/upcoming` });
  return data;
};
